/* Bedtextielonline (Claude): filterkeuze meenemen naar de productpagina.
   Filter je in een collectie op bv. Stevigheid: Stevig of Maat: 2-persoons, dan opent een klik op een product meteen die
   uitvoering (?variant=...) in plaats van de eerste. Werkt voor elke filter waarvan de naam gelijk is aan een
   productoptie: filter.p.m.custom.<naam>, filter.v.option.<naam> of filter.v.m.custom.<naam>.
   Gegroepeerde filterwaarden (gid://shopify/FilterSettingGroup/...) worden vertaald naar hun label op de pagina;
   '200 x 200 cm' past dan ook op de optie '200 x 200 cm + 2 kussenslopen'.
   Filters die niet op een optie passen, worden genegeerd. Geladen vanuit layout/theme.liquid (collecties en zoekpagina). */
(function () {
  if (window.__btolFiltervariant) return;
  window.__btolFiltervariant = true;

  function label(waarde) {
    if (String(waarde).indexOf('gid://') !== 0) return waarde;
    var ins = document.querySelectorAll('input[value="' + String(waarde).replace(/"/g, '') + '"]');
    for (var i = 0; i < ins.length; i++) {
      var l = ins[i].id && document.querySelector('label[for="' + ins[i].id + '"]');
      var t = l && l.textContent.replace(/\(\d+\)/g, '').replace(/\s+/g, ' ').trim();
      if (t) return t;
    }
    return waarde;
  }

  function wensen() {
    var w = {}, n = 0;
    new URLSearchParams(location.search).forEach(function (v, k) {
      var m = k.match(/^filter\.(?:p\.m\.custom|v\.m\.custom|v\.option)\.(.+)$/);
      if (!m) return;
      var naam = m[1].toLowerCase();
      (w[naam] = w[naam] || []).push(String(label(v)).toLowerCase());
      n++;
    });
    return n ? w : null;
  }

  function past(optie, wil) {
    optie = String(optie).toLowerCase();
    for (var i = 0; i < wil.length; i++) {
      if (optie === wil[i] || optie.indexOf(wil[i] + ' ') === 0) return true;
    }
    return false;
  }

  function kies(p, w) {
    var lijst = p.variants || [];
    (p.options || []).forEach(function (o, i) {
      var naam = String(o.name || o).toLowerCase();
      var wil = w[naam];
      if (!wil) return;
      var sub = lijst.filter(function (v) { return past(v.options[i], wil); });
      if (sub.length) lijst = sub;
    });
    if (lijst === p.variants) return null;
    return lijst.filter(function (v) { return v.available; })[0] || lijst[0] || null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a || !a.closest('.product-card, product-card')) return;
    var w = wensen();
    if (!w) return;
    var u = new URL(a.href, location.origin);
    if (u.searchParams.get('variant')) return;
    var handle = (u.pathname.split('/products/')[1] || '').split('/')[0];
    if (!handle) return;
    e.preventDefault();
    var weg = false;
    function ga(url) { if (weg) return; weg = true; location.href = url; }
    setTimeout(function () { ga(a.href); }, 1500);
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = kies(p, w);
        if (v) u.searchParams.set('variant', v.id);
        ga(u.toString());
      })
      .catch(function () { ga(a.href); });
  }, true);
})();

/* Bedtextielonline (Claude, 22/10/2026): kruisje op de actieve-filterlabeltjes laten werken.
   Sommige filterwaarden zijn in Shopify gegroepeerd (gid://shopify/FilterSettingGroup/...). De keuzehulp en
   andere links zetten de gewone tekst in de URL (bv. "240 x 220 cm"). Shopify toont dan wel het labeltje, maar
   url_to_remove haalt enkel de gid weg en laat de tekstwaarde staan, waardoor het kruisje niets deed.
   Hier halen we vlak voor de klik ook de tekstwaarde (en de gid) van die filter uit de link.
   De sleutel en het label komen uit data-btol-param / data-btol-label in snippets/active-facets.liquid. */
(function () {
  if (window.__btolFacetFix) return;
  window.__btolFacetFix = true;

  function norm(s) {
    return String(s || '').toLowerCase().replace(/\+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.removable-facet a[data-btol-param]');
    if (!a) return;
    try {
      var key = a.getAttribute('data-btol-param');
      var weg = [norm(a.getAttribute('data-btol-label')), norm(a.getAttribute('data-btol-value'))].filter(Boolean);
      var u = new URL(a.href, location.origin);
      var rest = u.searchParams.getAll(key).filter(function (v) { return weg.indexOf(norm(v)) === -1; });
      u.searchParams.delete(key);
      rest.forEach(function (v) { u.searchParams.append(key, v); });
      u.searchParams.delete('page');
      a.href = u.pathname + (u.search || '');
    } catch (err) {}
  }, true);
})();
